<template>
    <section class="content">
      <router-view></router-view>
    </section>
</template>

<script>
export default {
  name: 'packages',
  data () {
    return {
    }
  },
  computed: {
  }
}
</script>

<style>

</style>
